// services
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useClereProductService = () => {
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const handlerEndpoint = 'clere-products';

    const getAllClereProduct = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}`);
        return res.data;
    };

    const getClereProduct = async (id): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res.data;
    };

    const createClereProduct = async (
        project: any,
    ): Promise<any> => {
        const res = await axios.post(`${apiUrl}/${handlerEndpoint}`, project);
        return res.data;
    };

    const deleteClereProduct = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res.data;
    };

    const updateClereProduct = async (
        project: any,
    ): Promise<any> => {
        const res = await axios.put(`${apiUrl}/${handlerEndpoint}`, project);
        return res.data;
    };

    return {
        getAllClereProduct,
        getClereProduct,
        createClereProduct,
        deleteClereProduct,
        updateClereProduct,
    };
};
